import { useState, useEffect } from 'react'
import { fetchUserIdByPhone } from '../providers/userInsights'

interface UseUserByPhoneResult {
  userId: string | null
  isLoading: boolean
  error: Error | null
}

export function useUserByPhone(phone: string | null): UseUserByPhoneResult {
  const [userId, setUserId] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    if (!phone) {
      setUserId(null)
      return undefined
    }

    let cancelled = false
    setIsLoading(true)
    setError(null)

    const load = async (): Promise<void> => {
      try {
        const resolvedId = await fetchUserIdByPhone(phone)
        if (!cancelled) {
          setUserId(resolvedId)
        }
      } catch (err) {
        if (!cancelled) {
          setError(err instanceof Error ? err : new Error(String(err)))
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false)
        }
      }
    }

    load().catch(() => {
      // load() handles its own errors; nothing to do here
    })

    return () => {
      cancelled = true
    }
  }, [phone])

  return { userId, isLoading, error }
}
